import React, { useContext } from 'react';
import dayjs from 'dayjs';
import styles from './BookingHolderData.style';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import { useBookingData } from './BookingData.hook';
import { maskName } from '../../shared/utils/maskName';

export default function BookingHolderData({ bookings, isParentScope = false }) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { actions } = useBookingData(bookings);

  const isMultibooking = bookings.length > 1;

  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);

  // ✅ MULTIBOOKING (keep from HEAD)
  if (isMultibooking && bookings[0]?.bookingData) {
    const summary = actions.getSummaryData();

    return summary ? (
      <div className={`${themeClassName} booking-list-container`}>
        <div className={`${themeClassName} holder-data`}>
          {Object.entries(summary).map(([key, value], index) => {
            if (!value) return null;

            return (
              <div className={`${themeClassName} holder-row`} key={index}>
                <div className={`${themeClassName} holder-data-info`}>
                  {translate(`bookingHolder.${key}`)}
                </div>
                <div className={`${themeClassName} holder-data-data`}>
                  {Array.isArray(value) ? value.map((v, i) => <p key={i}>{v}</p>) : value}
                </div>
              </div>
            );
          })}
          <div className={`${themeClassName} holder-row`} />
        </div>
        {themeStyle}
      </div>
    ) : null;
  }

  // ✅ SINGLE BOOKING
  const holderData = actions.getHolderData(bookings[0]);

  return holderData ? (
    <div className={`${themeClassName} booking-list-container`}>
      <div className={`${themeClassName} holder-data`}>
        {Object.entries(holderData).map(([key, value], index) => {
          if (!value) return null;

          return (
            <div className={`${themeClassName} holder-row`} key={index}>
              <div className={`${themeClassName} holder-data-info`}>
                {translate(`bookingHolder.${key}`)}
              </div>
              <div className={`${themeClassName} holder-data-data`}>
                {key === 'roomType' && Array.isArray(value)
                  ? value.map((room, i) => <p key={i}>{room}</p>)
                  : key === 'holderName' && isParentScope
                  ? maskName(value)
                  : value}
              </div>
            </div>
          );
        })}
        <div className={`${themeClassName} holder-row`} />
      </div>
      {themeStyle}
    </div>
  ) : null;
}
